import { useContext } from "react";

import classnames from "classnames";

import { ScenarioContext } from "../contexts/ScenarioContext"


const CallOutText = ({ assessment }) => {

  const {scenario, isCurrentAssessmentFinding} = useContext(ScenarioContext)

  return  (
    <span className={classnames("callout", {currentCallOut: isCurrentAssessmentFinding(assessment.id)})}>
      {scenario.assessmentFindings[assessment.id]}
    </span>
  )

}

export default CallOutText;